import * as api from './adapter';
import { convertItem, convertItems } from './convertors/comments';

const requestParams = { query: { include: 'author', sort: '-created_at' } };

export default {
  /**
   * index
   * @param resource
   * @param id
   * @returns {Promise<void>}
   */
  index: async (resource, id, filter, sort = '-created_at') => {
    // QA bug 7.4 (2026-05-20). The seafarer-card "Interactions"
    // tab used to call `GET /users/:id/comments?...` — JR routed
    // that through `find_related_monomorphic_fragments`, which
    // silently dropped `filter[category]` (the BE filter
    // lambda's guard bails on `User`-rooted relations), ignored
    // `sort=-created_at` (JR passes `sort_primary: true`
    // internally on that path), and materialised
    // `CommentResource.records.includes(comment_event: …)` as a
    // 7-table LEFT OUTER JOIN cartesian product → ~7-second SQL,
    // ~333 queries on the page.
    //
    // For the `users` resource, route through the regular
    // `/comments` index with the new BE `filter :user_id` so
    // filters/sort/preload all run on a Comment-rooted relation.
    // Other resources (time_plans / vessels / crewing_agents)
    // keep their existing path — the same pattern can be
    // extended if QA reports identical symptoms there.
    const useUserIdFilter = id && resource === 'users';
    const url = useUserIdFilter
      ? 'comments'
      : (id ? `${resource}/${id}/comments` : 'comments');
    const effectiveFilter = useUserIdFilter
      ? { ...filter, user_id: id }
      : filter;

    const { data } = await api.read(url, {
      query: {
        ...requestParams.query,
        filter: effectiveFilter,
        page: { size: 999 },
        sort,
      },
    });

    return convertItems(data);
  },
  create: async ({ state: { newComment: body, addressable_id, addressable_type }, filter: { resource, id, category } }) => {
    const query = {
      type: 'comments',
      attributes: {
        body,
        addressable_id,
        addressable_type,
        category: resource === 'users' ? category : null,
      },
    };
    
    if(id) {
      query.relationships = {
        [resource]: { // time_plans -> time_plan OR users -> user
          data: [{ id, type: resource }],
        },
      };
    }

    const { data: json } = await api.create(query, requestParams);

    return convertItem(json);
  },
  createFull: async ({ resource, userId: id, ...attributes }) => {
    const { data: json } = await api.create({
      type: 'comments',
      attributes,
      relationships: {
        [resource]: { // time_plans -> time_plan OR users -> user
          data: [{ id, type: resource }],
        },
      },
    }, requestParams);

    return convertItem(json);
  },
  delete: async (id) => api.destroy({ id, type: 'comments' }),
};
